import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import ghalo from '../ghalo.jpg'
import ebi from '../ebi.jpg'

function About() {

  return (
  <>
    <Navbar />
      <div>
        <div className='about-main'>
          <h3>Meet the Team</h3>
          <h5 className='team-content'>{teamMessage}</h5>
          <div className='mapPhoto'>
            {persons.map((item)=>
            <Photo key={item.id} src={item.src} label={item.name} />)}
          </div>
          <div className='about-content'> 
            {content.map((item)=> 
            <AboutContent topic={item.topic} wordage={item.wordage} />)}
          </div>
        </div>
      </div>

    <Footer />

  </>
  )
}

export default About

const persons = [
  {
    id: 1,
    name: 'Ghalome Birigeni',
    src: ghalo
  },
  {
    id: 2,
    name: 'Ebi Birigeni',
    src: ebi
  }
]; 

const teamMessage = "Behind Briggs Flavours is a team of passionate food lovers, chefs, and travel enthusiasts dedicated to bringing you the best of the culinary world. With our combined expertise and love for all things food-related, we curate engaging content and recommendations to inspire your culinary adventures."

const content = [
  {
    topic: "Our Mission",
    wordage: "At Briggs Flavours, our mission is to celebrate the art of cooking and the joy of sharing delicious meals with loved ones. We strive to create a vibrant and inclusive community where food enthusiasts from all walks of life can come together to explore, learn, and indulge in their culinary passions."
  },
  {
    topic: "Expert Recommendation",
    wordage: "Discover hidden culinary gems and must-visit dining destinations with our expert recommendations. From cozy neighborhood cafes to Michelin-starred restaurants, we'll guide you to the best culinary experiences for unforgettable dining adventures.",

  },
  {
    topic: "Get in Touch",
    wordage: "Have questions, suggestions, or just want to say hello? We'd love to hear from you! Feel free to reach out to us via email, social media, or through our website. Your feedback is invaluable to us as we strive to make [Your Website Name] the ultimate destination for food lovers everywhere."
    
    
  }
]

function Photo({src, label}){
  return (
    <div className='photo-card'>
      <img src={src} alt='label' className='imgPhoto'/>
      <h4>{label}</h4>
    </div>
  )
}

function AboutContent ({ topic, wordage }){
  return (
    <>
      <h3>{topic}</h3>
      <p>{wordage}</p>
    </>
  )

}